import { Device } from '../common/device';
import { MixpanelSession } from '../mixpanel/mixpanel';
import { SupportedCurrencies } from '../payment';

export { CheckoutEntryPath, CheckoutSource } from '../mixpanel/mixpanel';

export enum AnalyticsEventTypes {
  BeginCheckout = 'begin_checkout',
  ChoseAccountProgram = 'choose_account_program',
  LoginSuccess = 'login_success',
  RegisterSuccess = 'sign_up_completed_successfully',
  PageView = 'pageview',
  NewAccountClick = 'new_account_cta_click',
  RegisterAsAffiliate = 'affiliate_plan_upgrade_cta',
  LoginFail = 'login_fail',
  RegistrationFail = 'sign_up_fail',
  Logout = 'logout',
  AddPaymentInfo = 'add_payment_info',
  Purchase = 'purchase',
  EndPurchase = 'end_purchase',
  AssetSelected = 'asset_selected',
  GroupSelected = 'group_selected',
  AddToCart = 'add_to_cart',
  AssetSelectionViewed = 'asset_selection_viewed',
  AssetSelectionSelected = 'asset_selection_selected',
  AssetSelectionCompleted = 'asset_selection_completed',
  ViewItem = 'view_item',
}

export enum AnalyticAuthType {
  Email = 'Email',
  Google = 'Google',
}

export interface CheckoutEcommerce {
  currency: SupportedCurrencies;
  value: number;
  items: CheckoutEcommerceItem[];
}

export interface CheckoutEcommerceItem {
  item_id: string;
  item_name: string;
  price: number;
  quantity: number;
  group_name?: string;
  account_size?: string;
  trading_system: string;
}

/**
 * Google Analytics session properties
 */
export interface GoogleAnalyticsSession {
  googleClientId?: string;
  sessionId?: string;
  device?: Device;
  ip?: string;
}

/**
 * Combined analytics session (Google Analytics + Mixpanel)
 */
export type AnalyticsSession = GoogleAnalyticsSession & MixpanelSession;
